import { TsrctNegotiationCaseStatus } from '@/generated/gql/graphql';

interface IsNegotiationCaseAwardableArgs {
  status: TsrctNegotiationCaseStatus;
  isAwardable: boolean;
  awardableConfirmedQuotes: boolean;
}

export const isNegotiationCaseAwardable = ({
  status,
  isAwardable,
  awardableConfirmedQuotes,
}: IsNegotiationCaseAwardableArgs): boolean => {
  if (!isAwardable) {
    return false;
  }

  if (status === TsrctNegotiationCaseStatus.AGREEMENT_CONFIRMED) {
    return true;
  }

  if (status === TsrctNegotiationCaseStatus.NEGOTIATION_DETAILS_CONFIRMED) {
    return awardableConfirmedQuotes;
  }

  return false;
};
